<template>
	<div class="form-group">
		<div :class="hasIcon(icon)">
			<span v-if="iconDir === 'left'" class="input-group-text">
				<i :class="getIcon(icon)"></i>
			</span>
			<input :type="inputType" class="form-control" :class="getClasses(size, valid)" :name="name" :id="id" :value="displayValue" :placeholder="placeholder" :isRequired="isRequired" :disabled="isDisabled" @input="emitValue($event.target.value)" />
			<span v-if="iconDir === 'right'" class="input-group-text">
				<i :class="getIcon(icon)"></i>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'argon-input',
	props: {
		size: {
			type: String,
			default: 'default',
		},
		valid: {
			type: Boolean,
			default: false,
		},
		icon: String,
		iconDir: String,
		name: String,
		id: String,
		value: String,
		placeholder: String,
		type: String,
		isRequired: Boolean,
		isDisabled: { type: Boolean, default: false },
		inputName: String,
	},
	data() {
		return {
			inputValue: this.value !== null && this.value !== undefined ? String(this.value) : '',
		}
	},
	computed: {
		displayValue() {
			return this.inputValue || this.value
		},
		inputType() {
			return typeof this.value === 'number' ? 'text' : this.type // Mudando para 'text' se for número
		},
	},
	methods: {
		getClasses: (size, valid) => {
			let sizeValue, isValidValue

			sizeValue = size ? `form-control-${size}` : null

			isValidValue = valid ? `${valid}` : 'invalid'

			return `${sizeValue} ${isValidValue}`
		},
		getIcon: icon => (icon ? icon : null),
		hasIcon: icon => (icon ? 'input-group' : null),
		emitValue(newValue) {
			this.inputValue = newValue
			const data = {
				type: this.type,
				value: this.inputValue,
			}
			if (this.name) {
				data.name = this.name
			}
			this.$emit('change-value', data)
		},
	},
}
</script>
